import React from 'react';
import { Link } from 'react-router-dom';

const Error = () => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <section className="error-404-section section-padding">
            <div className="error-404-shape" aria-hidden="true" />
            <div className="container">
                <div className="error-404-wrapper">
                    <div className="error-illustration">
                        <div className="error-code" aria-hidden="true">
                            <span>4</span>
                            <span>0</span>
                            <span>4</span>
                        </div>
                        <p className="error-tagline">Precision care starts with the right path.</p>
                    </div>
                    <div className="error-message">
                        <h3>Let's get you back on track</h3>
                        <p>
                            The page you're looking for may have moved or no longer exists. Choose one of the options
                            below to continue your journey to lasting relief.
                        </p>
                        <div className="error-actions">
                            <Link onClick={ClickHandler} to="/" className="theme-btn primary">
                                Return Home
                            </Link>
                            <Link onClick={ClickHandler} to="/contact" className="theme-btn secondary">
                                Contact the Clinic
                            </Link>
                        </div>
                        <ul className="error-links">
                            <li>
                                <Link onClick={ClickHandler} to="/about">
                                    Meet Dr. Pereira
                                </Link>
                            </li>
                            <li>
                                <Link onClick={ClickHandler} to="/blog">
                                    Explore Patient Insights
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Error;
